import React from 'react';

import { StyledModal, FolderSelector } from 'common/components';
import AddToFolderActions from 'common/components/grid-view/components/add-to-folder/AddToFolderActions';

import { useAddToFolder } from 'hooks/useAddToFolder';
import { useGlobalModal } from 'hooks';

import './ModalAddToFolder.less';

const ModalAddToFolder = (props) => {
  const { dataItem, dataType, hasPermissionAddToFolder } = props;

  const { MODAL_NAMES, checkModalVisible, closeModalList } = useGlobalModal();
  const isShowAddToFolder = checkModalVisible(MODAL_NAMES.ADD_ITEMS_TO_FOLDER);
  const {
    folderSelectorRef,
    onSelectFolder,
    onBreadcrumbChange,
    onExpandFolder,
    handleSubmit,
    handleReloadFolderList,
    selectedFolder,
    currentFolderId,
    addToFolderLoading,
  } = useAddToFolder({
    shouldShowConfirm: false, //* hide confirmation in detail, because of missing name
    close: () => {
      handleCloseModal();
    },
  });

  const handleCloseModal = () => {
    closeModalList([
      MODAL_NAMES.CREATE_FOLDER,
      MODAL_NAMES.ADD_ITEMS_TO_FOLDER,
    ]);
  };

  const handleSuccessCallback = (folder) => {
    handleSubmit([{ id: dataItem?.id, type: dataType }], folder);
  };

  const folderIdToAdd = selectedFolder?.id || currentFolderId;

  const selectedFolderId =
    selectedFolder?.id !== 'home' ? selectedFolder?.id : null;

  return (
    <StyledModal
      title={'Add to Folder'}
      visible={isShowAddToFolder}
      bodyStyle={{ height: '70vh' }}
      maskClosable={false}
      destroyOnClose
      onCancel={handleCloseModal}
      footer={
        <AddToFolderActions
          loading={addToFolderLoading}
          parentId={selectedFolderId || currentFolderId}
          currentFolderId={currentFolderId}
          disableSubmitButton={!folderIdToAdd || !hasPermissionAddToFolder}
          onCancel={handleCloseModal}
          onSubmit={() =>
            handleSubmit([{ id: dataItem?.id, type: dataType }], selectedFolder)
          }
          successCallback={handleSuccessCallback}
        />
      }
    >
      <FolderSelector
        ref={folderSelectorRef}
        onSelectFolder={onSelectFolder}
        onBreadcrumbChange={onBreadcrumbChange}
        onExpandFolder={onExpandFolder}
      />
    </StyledModal>
  );
};
export default ModalAddToFolder;
